import _ from 'lodash'
import moment from 'moment'
import type { Hive } from '../../src/modules/hive'
import { syncLog } from '../../src/utils/loggers'
import { IDB_formsReadAll, IDB_formsWrite } from '../IDB/IDB.table.form'
import { IDB_unitListsReadAll, IDB_unitListsWrite } from '../IDB/IDB.table.unitList'
import type { Sync_SyncResult } from './Sync.master'

export async function Sync_clearOldData(hive: Hive, syncResult: Sync_SyncResult) {
    let nextDeletion = hive.getObj<any>('nextDeletion')

    const hasUnitsLists = syncResult.response.unitLists ? syncResult.response.unitLists.length > 0 : false
    const hasForms = syncResult.response.forms ? syncResult.response.forms.length > 0 : false
    const override = hasUnitsLists || hasForms

    if (
        !override &&
        nextDeletion &&
        (!nextDeletion.unitListItem || new Date(nextDeletion.unitListItem) > new Date()) &&
        (!nextDeletion.formQuestion || new Date(nextDeletion.formQuestion) > new Date())
    ) {
        return false
    }

    syncLog('Clearing old data')

    let unitLists = await IDB_unitListsReadAll()

    let forms = await IDB_formsReadAll()

    /* Find all unit lists which have a expired unit */
    const updatedUnitLists = unitLists
        .filter(
            (unitList) =>
                unitList.units.filter((unit) => unit.endDate && new Date(unit.endDate) < new Date()).length > 0
        )
        /* mutate each unit list by filtering out expired units */
        .map((unitList) => {
            unitList.units = unitList.units.filter((unit) => !unit.endDate || new Date(unit.endDate) > new Date())
            return unitList
        })

    await IDB_unitListsWrite(updatedUnitLists)

    /* Find all forms which have a expired question */
    const updatedForms = forms
        .filter(
            (form) =>
                form.questions.filter((question) => question.endDate && new Date(question.endDate) < new Date())
                    .length > 0
        )
        /* Mutate each form by filtering out expired questions */
        .map((form) => {
            form.questions = form.questions.filter(
                (question) => !question.endDate || new Date(question.endDate) > new Date()
            )
            return form
        })

    await IDB_formsWrite(updatedForms)

    // Update next deletion - need to get the data again from indexedb to ensure we check existing
    // data not just data that was changed above
    function sortDates(a: Date, b: Date) {
        if (!moment(a).isValid()) return 1
        if (!moment(b).isValid()) return -1
        return a.getTime() - b.getTime()
    }

    unitLists = await IDB_unitListsReadAll()

    forms = await IDB_formsReadAll()

    // Reset next deletion to an empty object (or first time to an object) as we have gotten the
    // values from null
    nextDeletion = {}

    nextDeletion.unitListItem = _.flatten(unitLists.map((unitList) => unitList.units))
        .filter((unit) => unit.endDate)
        .map((unit) => new Date(unit.endDate))
        .sort(sortDates)
        .shift()

    nextDeletion.formQuestion = _.flatten(forms.map((form) => form.questions))
        .filter((question) => question.endDate)
        .map((question) => new Date(question.endDate))
        .sort(sortDates)
        .shift()

    hive.setObj('nextDeletion', nextDeletion)

    return true
}
